import { ENV } from '@/environment/client';

// utilities to evaluate the current application environment
export const isDev =
  ENV.NEXT_PUBLIC_VERCEL_ENV === 'development' || ENV.NEXT_PUBLIC_VERCEL_ENV === undefined;
export const isProd = ENV.NEXT_PUBLIC_VERCEL_ENV === 'production';
export const isPreview = ENV.NEXT_PUBLIC_VERCEL_ENV === 'preview';
export const isTest = process.env.NODE_ENV === 'test';

export const BASE_URL_PRODUCTION = 'https://matcha.xyz';

// returns the baseURL of the application in the current environment
export const getBaseURL = (): string => {
  let hostname = '',
    port = '',
    protocol = '';

  if (isTest) {
    // In test environment, use production URL
    hostname = 'matcha.xyz';
    protocol = 'https';
  } else if (isProd) {
    hostname = 'matcha.xyz';
    protocol = 'https';
  } else if (isPreview) {
    const vercelUrl = ENV.NEXT_PUBLIC_VERCEL_URL;
    if (vercelUrl) {
      hostname = vercelUrl;
      protocol = 'https';
    } else if (typeof window !== 'undefined') {
      return window.location.origin;
    } else {
      hostname = BASE_URL_PRODUCTION.replace(/^https?:\/\//, '');
      protocol = 'https';
    }
  } else {
    hostname = 'localhost';
    protocol = 'http';
    port = ':3000';
  }

  return `${protocol}://${hostname}${port}`;
};
